import React from 'react';
import PropTypes from 'prop-types';

import { Image } from 'components/core/Image';
import { Paragraph } from 'components/core/Typography';

import './HowItWorks.scss';

export default function HowItWorks({ steps }) {
	return (
		<ol className="how-it-works">
			{steps.map((step, idx) => (
				<li
					className="step"
					key={step.stepName}
				>
					<Image
						src={step.image}
						className="step-image"
						alt={`${step.stepName} image`}
					/>
					<Paragraph
						size="small"
						last={idx !== steps.length - 1}
					>
						{idx + 1}. {step.stepName}
					</Paragraph>
					{step.subtext && (
						<Paragraph className="step-subtext">
							{step.subtext}
						</Paragraph>
					)}
				</li>
			))}
		</ol>
	);
}

HowItWorks.propTypes = {
	steps: PropTypes.arrayOf(
		PropTypes.shape({
			image: PropTypes.string.isRequired,
			text: PropTypes.string,
			subtext: PropTypes.string,
		}),
	).isRequired,
};
